/* Mjuk utfällning och stängning av frågekort (19 okt 2026).
   Gäller frågekorten på sidor, policyer och i bloggar: details.nv-fq-card, details.nv-ff-card,
   details med klass som slutar på -info-card och <details> i text från redigeraren (.rte).
   Höjden animeras från stängd till öppen och tillbaka på 0.4 s med samma kurva som resten av
   temat, och svaret tonas in. Under stängningen får kortet attributet data-nv-closing så att
   plustecknet vänds direkt (theme.css sektion 138). Kollektionernas NV-FAQ har egen animation.
   Vid minskad rörelse öppnas och stängs korten som vanligt utan animation. */
(function () {
  'use strict';
  var SEL = 'details.nv-fq-card, details.nv-ff-card, details[class$="-info-card"], .rte details:not([class])';
  var DUR = 400;
  var EASE = 'cubic-bezier(0.28, 0.11, 0.32, 1)';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function closedHeight(d, summary) {
    var cs = getComputedStyle(d);
    return summary.getBoundingClientRect().height +
      parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) +
      parseFloat(cs.paddingTop);
  }

  function finish(d) {
    d._nvAnim = null;
    d.style.height = '';
    d.style.overflow = '';
  }

  function run(d, from, to, done) {
    if (d._nvAnim) d._nvAnim.cancel();
    d.style.overflow = 'hidden';
    var a = d.animate({ height: [from + 'px', to + 'px'] }, { duration: DUR, easing: EASE });
    d._nvAnim = a;
    a.onfinish = function () { finish(d); if (done) done(); };
    a.oncancel = function () { if (d._nvAnim === a) finish(d); };
  }

  function fadeIn(d, summary) {
    var kids = Array.prototype.filter.call(d.children, function (c) { return c !== summary; });
    kids.forEach(function (c) {
      if (c.animate) c.animate({ opacity: [0, 1] }, { duration: DUR, easing: EASE });
    });
  }

  function open(d, summary) {
    var from = d._nvAnim || d.hasAttribute('data-nv-closing') ? d.getBoundingClientRect().height : closedHeight(d, summary);
    d.removeAttribute('data-nv-closing');
    if (d._nvAnim) { d._nvAnim.oncancel = null; d._nvAnim.cancel(); finish(d); }
    d.open = true;
    var to = d.getBoundingClientRect().height;
    fadeIn(d, summary);
    run(d, from, to);
  }

  function close(d, summary) {
    var from = d.getBoundingClientRect().height;
    var to = closedHeight(d, summary);
    d.setAttribute('data-nv-closing', '');
    run(d, from, to, function () {
      d.open = false;
      d.removeAttribute('data-nv-closing');
    });
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var d = summary.parentElement;
    if (!d || d.tagName !== 'DETAILS' || !d.matches(SEL)) return;
    if (!d.animate || (reduce && reduce.matches)) return;
    var link = e.target.closest('a');
    if (link && summary.contains(link)) return;
    e.preventDefault();
    if (d.open && !d.hasAttribute('data-nv-closing')) {
      close(d, summary);
    } else {
      open(d, summary);
    }
  });
})();
